import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { LateralBar } from '../../../../../components/LateralBar';
import {
  SubscriptionCustomerItemProps,
  SubscriptionItemProps,
} from '../../../../../store/subscription/types';

export interface SubscriptionSolicitationCardProps {
  title: string;
  customer: SubscriptionCustomerItemProps;
  subscription: SubscriptionItemProps;
  quantity: number;
  hasLeftOvers: boolean;
  setHasLeftOvers: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SubscriptionSolicitationCard: React.FC<SubscriptionSolicitationCardProps> = ({
  title,
  customer,
  quantity,
  subscription,
  hasLeftOvers,
  setHasLeftOvers,
}) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} position="relative">
      <LateralBar barColor="product.rendavariavel" />
      <VStack p="inset.sm" space="stack.xxxs">
        <UI.Text variant="semibold" fontSize={Typography['fontsize.lg']}>
          {title}
        </UI.Text>
        <VStack space="stack.nano">
          <UI.Text variant="semibold" color="neutral.darkest">
            Cliente
          </UI.Text>
          <Stack
            flex={1}
            borderRadius={BoxBorder.thick}
            bg="background"
            px="inline.xxxs"
            py="stack.nano">
            <UI.Text color="neutral.medium">{customer.customerNameNormalized}</UI.Text>
          </Stack>
        </VStack>
        <UI.Checkbox
          onChange={() => setHasLeftOvers(!hasLeftOvers)}
          options={[{ label: 'Participa de sobras', value: 'leftovers' }]}
          selectedValues={hasLeftOvers ? ['leftovers'] : []}
          testId="leftovers-checkbox"
        />
        <VStack space="stack.nano">
          <UI.Text variant="semibold" color="neutral.darkest">
            Retratação
          </UI.Text>
          <HStack
            flex={1}
            borderRadius={BoxBorder.thick}
            bg="background"
            px="inline.xxxs"
            py="stack.nano"
            justifyContent="space-between"
            alignItems="center">
            <UI.Text color="neutral.medium">NÃO RETRATA</UI.Text>
            <UI.Icon name="ChevronDown" size="xxs" color="neutral.light" />
          </HStack>
        </VStack>

        <HStack space="stack.nano" justifyContent="space-between" alignItems="center">
          <UI.Text>Quantidade Solicitada</UI.Text>
          <UI.Text color="neutral.black" variant="semibold">
            {quantity}
          </UI.Text>
        </HStack>
        <HStack space="stack.nano" justifyContent="space-between" alignItems="center">
          <UI.Text>Total Financeiro</UI.Text>
          <UI.Text color="neutral.black" variant="semibold">
            {Utils.Mask.Money(subscription.unitaryPrice * quantity)}
          </UI.Text>
        </HStack>
        <UI.Notice
          testID="notice"
          textObjects={[
            {
              text: `Saldo necessário em conta corrente na data de liquidação (${subscription?.limitDateFormatted})`,
              variant: 'regular',
            },
          ]}
          backgroundColor={Utils.ColorToken.WithOpacity(
            'feedback.attention.lightest',
            'opacity.medium'
          )}
        />
      </VStack>
    </UI.Shadow>
  );
};
